/**
 * Ring / Pendant Style — SjImageStepper over Thinkspace's style select.
 *
 * Thumbs: assets/top-{code}.png (400×400 from Desktop/bands/grey tops)
 * Config:  window.__SJ_IMAGE_STEPPER_CONFIG__.topImages
 *
 * Raised-filigree / F variants reuse the base style art via the map
 * (e.g. 226 → 249 Eternity, 44 → 252 Journey, 245F → 245).
 *
 * Depends on: sj-3d-builder.js, sj-image-stepper.js/.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B || typeof window.SjImageStepper !== 'function') return;

  var OPTION_NAMES = ['Ring Style', 'Pendant Style'];
  var HOST_ATTR = 'data-sj-image-stepper-host';
  var ENHANCED_ATTR = 'data-sj-ring-stepper-ready';

  /**
   * Builder top-style order. Raised-filigree SKUs sit next to their base.
   * Styles not on this list land just before 71 / Signet.
   */
  var TOP_STYLE_ORDER = [
    '123', '245F', '245', '193', '177',
    '249', '226', '250',
    '252', '44', '222', '228', '247', '227', '237', '223', '234', '224',
    '313', '312', '175',
    '311', '310',
    '71', 'SIG',
  ];

  function styleOrderIndex(value) {
    var key = String(value || '').trim().toUpperCase();
    for (var i = 0; i < TOP_STYLE_ORDER.length; i++) {
      if (TOP_STYLE_ORDER[i].toUpperCase() === key) return i;
    }
    return TOP_STYLE_ORDER.length - 2;
  }

  function topImageMap() {
    var m = B.stepperConfig().topImages;
    return m && typeof m === 'object' ? m : {};
  }

  /**
   * Shopper-facing number/name only. Option `value` (the Thinkspace SKU) is
   * unchanged — pricing, viewer, cart, and production still use that code.
   */
  var DISPLAY_SKU = {
    '226': '249',
    '44': '252',
    '227': '247',
    '224': '234',
  };
  var DISPLAY_NAME = {
    '245': 'Prestige W/ Raised Wire',
  };

  function mapLookup(map, value) {
    var raw = String(value || '').trim();
    if (map[raw]) return map[raw];
    var upper = raw.toUpperCase();
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toUpperCase() === upper) return map[keys[i]];
    }
    return '';
  }

  /**
   * Strip cards: name + style number under it ("Tradition" / "123").
   * Chevron dropdown: "Eternity - 249".
   * Thinkspace option text is often "Eternity (249)" or just "Eternity"; value is the style SKU.
   */
  function parseTopNameSku(value, text) {
    var sku = String(value || '').trim();
    var t = String(text || '').replace(/\s+/g, ' ').trim();
    var name = t;

    var paren = t.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (paren) {
      name = paren[1].trim();
      if (!sku) sku = paren[2].trim();
    } else {
      var leadingSku = t.match(/^(\d+[A-Za-z]?)\s*[-–—]?\s+(.+)$/);
      if (leadingSku) {
        if (!sku) sku = leadingSku[1].trim();
        name = leadingSku[2].trim();
      } else if (t && sku && t.toUpperCase() === sku.toUpperCase()) {
        name = '';
      }
    }

    if (!name) name = sku;
    return { name: name, sku: sku };
  }

  function displayName(value, text) {
    return mapLookup(DISPLAY_NAME, value) || parseTopNameSku(value, text).name;
  }

  function displaySku(value, text) {
    return mapLookup(DISPLAY_SKU, value) || parseTopNameSku(value, text).sku;
  }

  function displayLabel(value, text) {
    return displayName(value, text);
  }

  function menuLabel(value, text) {
    var name = displayName(value, text);
    var sku = displaySku(value, text);
    if (name && sku && name.toUpperCase() !== sku.toUpperCase()) {
      return name + ' - ' + sku;
    }
    return name || sku;
  }

  function skuLabel(value, text) {
    var name = displayName(value, text);
    var sku = displaySku(value, text);
    return sku && name && sku.toUpperCase() !== name.toUpperCase() ? sku : '';
  }

  function imageUrlFor(value) {
    var map = topImageMap();
    var raw = String(value || '').trim();
    if (!raw) return '';
    var keys = [
      raw,
      raw.toUpperCase(),
      raw.toLowerCase(),
      raw.replace(/F$/i, ''),
      raw.replace(/F$/i, '').toUpperCase(),
    ];
    for (var i = 0; i < keys.length; i++) {
      if (map[keys[i]]) return map[keys[i]];
    }
    return '';
  }

  function readSelectOptions(select) {
    return Array.from(select.options || [])
      .filter(function (opt) {
        return !opt.disabled && String(opt.value || '').trim() !== '';
      })
      .map(function (opt) {
        var value = String(opt.value).trim();
        var text = opt.textContent;
        return {
          value: value,
          label: displayLabel(value, text),
          subtitle: skuLabel(value, text),
          menuLabel: menuLabel(value, text),
          imageUrl: imageUrlFor(value),
        };
      })
      .sort(function (a, b) {
        return styleOrderIndex(a.value) - styleOrderIndex(b.value);
      });
  }

  function enhanceField(field) {
    if (!field || field.getAttribute(ENHANCED_ATTR) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(ENHANCED_ATTR, '1');
    field.setAttribute(HOST_ATTR, 'ring');

    var optionName = field.getAttribute('data-option') || 'Ring Style';
    var mount = document.createElement('div');
    mount.className = 'sj-image-stepper-mount';
    field.appendChild(mount);

    var stepper = new window.SjImageStepper({
      mountEl: mount,
      kind: 'ring',
      layout: 'strip',
      visibleCount: 3,
      ariaLabel: optionName,
      options: readSelectOptions(select),
      getValue: function () {
        return String(select.value || '');
      },
      setValue: function (value) {
        B.setSelectValue(select, value);
      },
    });

    field._sjRingStepper = stepper;

    var mo = new MutationObserver(function () {
      var next = readSelectOptions(select);
      var prevKey = stepper.options
        .map(function (o) {
          return o.value;
        })
        .join('|');
      var nextKey = next
        .map(function (o) {
          return o.value;
        })
        .join('|');
      if (prevKey !== nextKey) {
        stepper.setOptions(next);
      } else {
        stepper.syncFromValue(undefined, { keepWindow: true });
      }
    });
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected'],
    });
    select.addEventListener('change', function () {
      stepper.syncFromValue(undefined, { keepWindow: false });
    });
    field._sjRingStepperMo = mo;
  }

  function scan() {
    OPTION_NAMES.forEach(function (name) {
      document
        .querySelectorAll('[data-option="' + name + '"]')
        .forEach(enhanceField);
    });
  }

  B.bootOnWidget(function (widget) {
    // Widget-scoped observer is enough — step mounts land inside x-3d-product-options.
    B.watchWidget(widget, scan);
  });
})();
